import { create } from "zustand";

type Studio = {
  id: string;
  name: string;
};

export type StudiosDataStore = {
  selectedStudios: Studio[];
  setSelectedStudios: (selectedStudios: Studio[]) => void;
  clearStudiosData: () => void;
};

export const useStudiosData = create<StudiosDataStore>((set) => ({
  selectedStudios: [],
  setSelectedStudios: (selectedStudios) => set({ selectedStudios }),
  clearStudiosData: () =>
    set({
      selectedStudios: [],
    }),
}));
